import { useAuth } from 'hooks';
import licenseType, { licenseTypeToStringMap } from 'models/licenseType';
import styled from 'styled-components';

const UpsellSpan = styled.span`
  font-size: 14px;
  font-weight: 400;
  a {
    text-decoration: underline;
  }
`;

/**
 * Displays a license upsell hint when the user is missing academic or industry access.
 */
export const NLPLicenseUpsell = () => {
  const { hasLicense } = useAuth();

  const hasAcademic = hasLicense([licenseType.academic], true);
  const hasIndustry = hasLicense([licenseType.industry], true);

  if (hasAcademic && hasIndustry) return null;

  const missingLicense = !hasAcademic
    ? licenseTypeToStringMap[licenseType.academic]
    : licenseTypeToStringMap[licenseType.industry];

  return (
    <UpsellSpan>
      Some search filters aren't included in your licence.&nbsp;
      <a
        href='https://scileads.chilipiper.com/shared/laura-haldane/sales-demo'
        target='_blank'
        rel='noopener noreferrer'
      >
        Upgrade to {missingLicense}
      </a>
    </UpsellSpan>
  );
};
